import { render, staticRenderFns } from "./LogoutScreen.vue?vue&type=template&id=f6a62a64&scoped=true&"
import script from "./LogoutScreen.vue?vue&type=script&lang=js&"
export * from "./LogoutScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a62a64",
  null
  
)

export default component.exports